import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { TimesheetOvertimeRequestDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import EditOvertimeRequestModal from 'modules/attendance/components/ClockIn/Modals/OvertimeRequest/Edit'

import { useAttendanceDateNavigator } from '../lib/attendanceDateNavigatorContext'

const EmployeePeriodEditOvertimeRequestPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { employeeId } = useStrictParams<'employeeId' | 'year' | 'month'>()
  const { pathParams, stringDateFrom: startOn } = useAttendanceDateNavigator()

  const onClose = () => {
    navigate(navigation.clockIn.periodTypeYearMonthDay.fullPath(pathParams))
  }

  const { data } = useQuery(TimesheetOvertimeRequestDocument, {
    variables: {
      employeeIds: [+(employeeId || 0)],
      startOn: startOn,
    },
  })
  const overtimeRequests = data?.attendance?.overtimeRequests
  const overtimeRequest = overtimeRequests?.find((req) => req.date === startOn)

  return (
    <>
      {overtimeRequest && (
        <EditOvertimeRequestModal overtimeRequest={overtimeRequest} onClose={onClose} />
      )}
    </>
  )
}

export default EmployeePeriodEditOvertimeRequestPage
